module.exports = __webpack_public_path__ + "src/assets/img/share-wechat-hy.49b20a26.png";